import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PBtn } from "./ui";
import QuoteDocument, { QuoteSnapshot } from "./quote-document";
import { downloadQuotePdf } from "./quote-pdf";

export default function QuoteModal({ show, onHide, snapshot }: {
  show: boolean; onHide: () => void; snapshot: QuoteSnapshot;
}) {
  const { t } = useTranslation("supplierPricing");
  const source = useRef<HTMLDivElement>(null);
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const download = async () => {
    if (!source.current || pending.current) return;
    pending.current = true; setBusy(true); setError(false);
    try { await downloadQuotePdf(source.current, snapshot.quote_no); }
    catch { setError(true); }
    finally { pending.current = false; setBusy(false); }
  };
  return <Modal show={show} onHide={onHide} centered size="xl" dialogClassName="eb-pr eb-quote-modal">
    <div className="eb-quote-toolbar">
      <PBtn onClick={download} disabled={busy}>{busy ? t("common.loading") : t("quote.download")}</PBtn>
      <PBtn kind="secondary" onClick={onHide}>{t("common.close")}</PBtn>
    </div>
    {error && <p role="alert">{t("quote.downloadFailed")}</p>}
    <div className="eb-quote-viewport"><div ref={source}><QuoteDocument snapshot={snapshot} /></div></div>
  </Modal>;
}
